import React, { Suspense } from 'react';

/**
 * @example simple usage
 * const Heading = withSuspense(
 *   React.lazy(() => import('../Atoms/Heading/Heading')),
 *   null
 * );
 *
 * @example usage with fallback
 * const Heading = withSuspense(
 *   React.lazy(() => import('../Atoms/Heading/Heading')),
 *   Loading
 * );
 *
 * @example custom fallback consumer
 * const LazyLoadedComponent = withSuspense(React.lazy(() => import('../Component')), null);
 * <LazyLoadedComponent suspenseFallback={<div styles={{ width: '100px', height: '50px' }} />} />
 */
export function withSuspense(
  LazyLoadedComponent: unknown,
  Fallback: React.FC | React.ReactElement | null,
): (props: {
  suspenseFallback: React.ReactElement;
  [key: string]: unknown;
}) => React.ReactElement {
  return ({ suspenseFallback, ...otherProps }) => (
    // @ts-expect-error JSX element type 'Fallback' does not have any construct or call signatures
    <Suspense fallback={suspenseFallback || (Fallback && <Fallback />)}>
      {/* @ts-expect-error JSX element type 'LazyLoadedComponent' does not have any construct or call signatures */}
      <LazyLoadedComponent {...otherProps} />
    </Suspense>
  );
}
